import React, { Component } from 'react';
import { requestBase, apiroot } from "./Fetch-helpers";
import ClipLoader from "react-spinners/ClipLoader";
export default class TimePrice extends Component {

    constructor(props) {
        super(props);

        this.state = {
            totalPrice: "", leadTime: "", isUpdating: false
        };
    }

    componentDidMount() {
        this.updatePrice();
        this.updateProductionTime();
    }

    //async updateData() {
    //    //--!!!заглушка 
    //    //const _totalPrice = "Временно недоступно. Ведутся профилактические работы";
    //    //const _leadTime = _totalPrice;
    //    //this.setState({ totalPrice: _totalPrice, leadTime: _leadTime });
    //    //return;
    //    //++

    //    let up = this.updatePrice();
    //    let upt = this.updateProductionTime();

    //    const _totalPrice = await up;
    //    const _leadTime = await upt;

    //    this.setState({ totalPrice: _totalPrice, leadTime: _leadTime, isUpdatingtotalPrice: false, isUpdatingleadTime: false });
    //    //--
    //}

    //UpdateButton = () => {
    //    this.updatePrice();
    //    this.updateProductionTime();
    //}

    async updatePrice() {
        if (this.state.isUpdatingtotalPrice)
            return;

        try {
            this.setState({ isUpdatingtotalPrice: true });

            const params = this.props.URLParams;
            const response = await fetch(
                apiroot + "Configuration/GetTotalPrice/" + params.cfgid,
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                return "Сервис расчета цены вернул ошибку";
            }

            const data = await response.text();
            this.setState({ totalPrice: data, isUpdatingtotalPrice: false });
        }
        catch (err) {
            this.setState({ isUpdatingtotalPrice: false });
        }
    }

    async updateProductionTime() {
        if (this.state.isUpdatingleadTime)
            return;

        try {
            this.setState({ isUpdatingleadTime: true });

            const params = this.props.URLParams;
            const response = await fetch(
                apiroot + "Configuration/GetProductionTime/" + params.cfgid,
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                return "Ошибка сервиса расчета срока изготовления";
            }

            const data = await response.text();
            this.setState({ leadTime: data, isUpdatingleadTime: false });
        }
        catch (err) {
            this.setState({ isUpdatingleadTime: false });
        }
    }

    render() {
        return (
            <>                
                <div class="cdsFeatureItem">
                    <div class="cdsFeatureItemHeader">Срок изготовления</div>
                    <div className="headingModel">
                        {this.props.modelisValid ?
                            this.state.isUpdatingleadTime ?
                                <ClipLoader
                                    loading="true"
                                    size="12px"
                                    speedMultiplier="0.7"
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                                : this.state.leadTime
                            : 'Срок изготовления не определен'}
                    </div>
                </div>
                <div class="cdsFeatureItem">
                    <div class="cdsFeatureItemHeader">Стоимость</div>
                    <div className="headingModel">
                        {this.props.modelisValid ?
                            this.state.isUpdatingtotalPrice ?
                                <ClipLoader
                                    loading="true"
                                    size="12px"
                                    speedMultiplier="0.7"
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                                : this.state.totalPrice
                            : 'Стоимость не определена'}
                    </div>
                </div>
            </>
        );
    }
}